import { useEffect, useState } from 'react';

export const isReactNativeWebView = () => !!window.ReactNativeWebView;

/**
 * The RN bridge is injected after the first paint. Poll briefly so components
 * that mount on page load (e.g. the main Google button) switch to redirect
 * once window.ReactNativeWebView becomes available.
 */
export function useReactNativeWebView() {
  const [inWebView, setInWebView] = useState(() => isReactNativeWebView());

  useEffect(() => {
    if (inWebView) return undefined;

    const sync = () => {
      if (isReactNativeWebView()) {
        setInWebView(true);
      }
    };

    sync();

    const timer = setInterval(sync, 100);
    const stop = setTimeout(() => clearInterval(timer), 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(stop);
    };
  }, [inWebView]);

  return inWebView;
}
